export default __webpack_public_path__ + "static/media/quickstart-step-2.5849d094.jpg";